import { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "axios";

const UserContext = createContext(null);
const apiUrl = process.env.REACT_APP_API_URL;

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      axios
        .get(`${apiUrl}/getme`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        })
        .then((res) => {
          if (res.data && res.data._id) {
            setUser(res.data);
          } else {
            Cookies.remove("token");
            setUser(null);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch user:", err.message);
          if (err.response) {
            console.error("Status:", err.response.status);
            console.error("Response data:", err.response.data);
            if (err.response.status === 401 || err.response.status === 404) {
              Cookies.remove("token");
              setUser(null);
            }
          }
        });
    }
  }, []);

  const value = {
    user,
    setUser,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserContext;
